import {  Tree } from 'antd';


import "../styles/drawner.css";
import TitleComponent from './TitleComponent';
import {useResourceList} from '../hooks/useResourceList';

const ResourceList = () => {
  const { handleClick,treeData} = useResourceList();
  const { DirectoryTree } = Tree;

  return (
      <>
          <TitleComponent title="Portal DN Power BI" description="Reportes Power BI" keywords="Reportes Dichter&Neira"/>
          <DirectoryTree
            multiple
              defaultExpandedKeys={['0-0']}
              onSelect={handleClick}
              treeData={treeData}
              defaultExpandAll  
              selectable            
            />
        </>
    );
}

export default ResourceList;
